import {z} from '@hono/zod-openapi';

export const VoiceWebhookResponseSchema = z
  .object({status: z.enum(['accepted', 'duplicate']).openapi({example: 'accepted'})})
  .strict()
  .openapi('VoiceWebhookResponseSchema');
